import { render } from "./CardCategory.vue?vue&type=template&id=3b65785b&scoped=true"
import script from "./CardCategory.vue?vue&type=script&lang=js"
export * from "./CardCategory.vue?vue&type=script&lang=js"

import "./CardCategory.vue?vue&type=style&index=0&id=3b65785b&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b65785b"]])

export default __exports__